__turbopack_context__.v({
  "box": "enter-address-module-scss-module__4asnIW__box",
  "state": "enter-address-module-scss-module__4asnIW__state",
  "zip": "enter-address-module-scss-module__4asnIW__zip",
  "zipbox": "enter-address-module-scss-module__4asnIW__zipbox",
});
